import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/select";
import type { OperatorValue, RowState } from "@/components/advanceSearch/types";
import { OPERATOR_LABEL } from "@/components/advanceSearch/types";

export const OperatorSelect: React.FC<{
  row: RowState;
  operators: OperatorValue[];
  onChangeOperator: (op: OperatorValue) => void;
  error?: string;
}> = ({ row, operators, onChangeOperator, error }) => {
  React.useEffect(() => {
    if (!operators.length) return;
    if (!operators.includes(row.operator)) {
      onChangeOperator(operators[0]);
    }
  }, [operators, row.operator, onChangeOperator]);

  return (
    <div className="w-full">
      <Select value={row.operator} onValueChange={(value) => onChangeOperator(value as OperatorValue)}>
        <SelectTrigger
          aria-invalid={error ? "true" : "false"}
          className={`w-full justify-between rounded-md bg-white px-4 text-sm font-medium text-gray-700 shadow-none focus:ring-0 ${
            error ? "border border-red-500" : ""
          }`}
        >
          <SelectValue placeholder="Select operator" />
        </SelectTrigger>
        <SelectContent className="w-full min-w-[unset]">
          {operators.map((op) => (
            <SelectItem key={op} value={op}>
              {OPERATOR_LABEL[op] ?? op}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error && <span className="mt-1 block text-xs text-red-600">{error}</span>}
    </div>
  );
};
